import {Box, Button, Grid, Stack, Switch, Tab, Tabs, TextField, Typography, useTheme, useMediaQuery, Paper, Divider} from "@mui/material";
import React, {useEffect, useMemo, useState} from "react";
import {useSelector} from "../../../../redux/store";
import KisiDetay from "./KisiDetay";
import ClearIcon from '@mui/icons-material/Clear';
import IconButton from "@mui/material/IconButton";
import {People, PersonAdd, FilterList, Search} from '@mui/icons-material';

const Kisiler = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const sabitler = useSelector(state => state.app.sabitler);
    const [kisiId, setKisiId] = useState<number>(0);
    const [showPassive, setShowPassive] = useState<boolean>(false);
    const [searchQuery, setSearchQuery] = useState<string>("");

    // FİLTRELEME MANTIĞI
    const filteredKisiler = useMemo(() => {
        if (!sabitler?.kisiler) return [];
        return (sabitler.kisiler as any[]).filter((k: any) => {
            // Aktif/Pasif Filtresi
            const activeMatch = showPassive ? true : k.aktif;
            // Arama Filtresi (İsim, Soyisim veya Rumuz)
            const searchLower = searchQuery.toLowerCase();
            const searchMatch = searchQuery === "" ||
                k.isim.toLowerCase().includes(searchLower) ||
                k.soyisim.toLowerCase().includes(searchLower) ||
                k.rumuz.toLowerCase().includes(searchLower);

            return activeMatch && searchMatch;
        });
    }, [sabitler, showPassive, searchQuery]);

    useEffect(() => {
        if (kisiId === 0 && filteredKisiler.length > 0) {
            setKisiId(filteredKisiler[0].id);
        }
    }, [filteredKisiler, kisiId]);

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setKisiId(newValue);
    };

    return (
        <Box sx={{ mt: 1 }}>
            <Paper sx={{
 
                p: 2, 
                mb: 3, 
                borderRadius: '16px', 
                border: '1px solid rgba(0,0,0,0.05)', 
                boxShadow: '0 2px 12px rgba(0,0,0,0.04)' 
            }}>
                <Stack
                    direction={{xs: 'column', sm: 'row'}}
                    spacing={2}
                    alignItems={{ xs: 'stretch', sm: 'center' }}
                    justifyContent="space-between"
                >
                    <Stack direction="row" spacing={3} alignItems="center">
                        <Stack direction="row" spacing={1} alignItems="center" sx={{ flexShrink: 0 }}>
                            <FilterList fontSize="small" color="action" />
                            <Typography variant="body2" fontWeight={700}>Pasifleri Göster</Typography>
                            <Switch
                                size="small"
                                checked={showPassive}
                                onChange={(e) => setShowPassive(e.target.checked)}
                            />
                        </Stack>

                        <TextField
                            size="small"
                            placeholder="Filtrele..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            sx={{ 
                                width: { xs: '100%', sm: 250 },
                                '& .MuiOutlinedInput-root': { borderRadius: '10px' }
                            }}
                            InputProps={{
                                startAdornment: <Search fontSize="small" sx={{ mr: 1, color: 'action.active' }} />,
                                endAdornment: searchQuery && (
                                    <IconButton size="small" onClick={() => setSearchQuery("")}>
                                        <ClearIcon fontSize="small"/>
                                    </IconButton>
                                )
                            }}
                        />
                    </Stack>

                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => setKisiId(-1)}
                        startIcon={<PersonAdd />}
                        sx={{
                            borderRadius: '12px',
                            height: 44,
                            px: 3,
                            fontWeight: 800,
                            boxShadow: '0 4px 14px 0 rgba(0,71,0,0.2)',
                        }}
                    >
                        Yeni Kişi Ekle
                    </Button>
                </Stack>

                <Divider sx={{ my: 2, opacity: 0.6 }} />

                <Tabs
                    value={kisiId === -1 ? false : kisiId}
                    onChange={handleTabChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    allowScrollButtonsMobile
                    sx={{
                        '& .MuiTab-root': { 
                            fontWeight: 700, 
                            minHeight: 48, 
                            textTransform: 'none',
                            borderRadius: '8px',
                            mx: 0.5,
                            transition: 'all 0.2s'
                        },
                        '& .Mui-selected': { bgcolor: 'primary.light', color: 'primary.main' },
                        '& .MuiTabs-indicator': { display: 'none' }
                    }}
                >
                    {filteredKisiler.map((k: any) => (
                        <Tab
                            key={k.id}
                            label={k.rumuz || k.isim}
                            value={k.id}
                            sx={{
                                opacity: k.aktif ? 1 : 0.6,
                                fontStyle: k.aktif ? 'normal' : 'italic'
                            }}
                        />
                    ))}
                </Tabs>
            </Paper>

            <Box sx={{ mt: 2 }}>
                {(kisiId > 0 || kisiId === -1) && <KisiDetay kisiId={kisiId}/>}
            </Box>
        </Box>
    );
};

export default Kisiler;
